import { CAMPAING, filterField, STATUS, MAIN_CR, SUB_CR, tabsCRSearchOrdered, campaigns as campaignsTab, INTERNAL, DESCRIPTION, MAIN_CR_FIELD, SUB_CR_PATH } from './constants';

// Mapping filter -> openSearch operator
export const operatorMapping = {
  contains: 'CONTAINS',
  equal: 'EQUAL',
  like: 'LIKE',
  notEqual: 'NOT_EQUAL',
  containsObject: 'CONTAINS_OBJECTS',
  exists: 'EXISTS_FIELD',
  in: 'IN',
  containsAnyObject: 'CONTAINS_ANY_OBJECTS',
  between: 'BETWEEN',
};

const tableMenu = [
  { key: 'title', value: 'campaigns.title.translations', isInCRandSubCR: true, operator: operatorMapping.contains },
  { key: MAIN_CR_FIELD, value: 'campaigns.id', operator: operatorMapping.contains },
  { key: 'status', value: 'campaigns.status.value', isMultiFilter: true, operator: operatorMapping.in, format: 'ENUM_NAME' },
  { key: 'version', value: 'campaigns.version', isInCRandSubCR: true, operator: operatorMapping.equal },
  { key: 'versionDate', value: 'campaigns.versionDate', isInCRandSubCR: false, operator: operatorMapping.between },
  { key: DESCRIPTION.CONTACT_PERSON, value: 'campaigns.contactPerson.summary', isInCRandSubCR: true, operator: operatorMapping.contains },
  { key: 'department', value: 'campaigns.creationUser.department', isInCRandSubCR: true, operator: operatorMapping.contains },
  { key: 'asignedUser', value: 'campaigns.assignedUser.summary', isInCRandSubCR: true, operator: operatorMapping.contains },
  { key: 'created', value: 'campaigns.creationDate', isInCRandSubCR: false, operator: operatorMapping.between },
];

export const otherField = [{
  key: 'campaign',
  value: 'sub_campaign_feedbacks.campaigns',
  isMultiFilter: true,
  operator: operatorMapping.containsObject,
},
{
  key: SUB_CR_PATH,
  value: 'sub_campaigns.id',
  operator: operatorMapping.contains,
}];

export const lateralMenu = [
  { key: 'TRIGGER_SOURCE', value: 'descriptions.trigger.source', isMultiFilter: true, operator: operatorMapping.equal, isDropDownFields: true },
  { key: 'GB18285_RELEVANCE', value: 'classifications.affectsChina', operator: operatorMapping.equal, isDropDownFields: true },
  { key: 'CUSTOMER_RELEVANCY', value: 'classifications.relevance.customerRelevance', operator: operatorMapping.equal, isDropDownFields: true },
  { key: 'CLASSIFICATION', value: 'classifications.relevance.potentiallySCECertificationRelevant', isMultiFilter: true, operator: operatorMapping.in, isDropDownFields: true },
  { key: 'BLOCKING_RECOMMENDATION', value: 'classifications.blockingRecommendation', operator: operatorMapping.equal, isDropDownFields: true, format: 'ENUM_NAME' },
  { key: 'AFFECTED_PLANTS', value: 'affected_vehicles.affectedPlants', operator: operatorMapping.containsAnyObject, isDropDownFields: true },
  { key: 'AFFECTED_MODEL_SERIES', value: 'affected_vehicles.affectedPlants.affectedSeries', operator: operatorMapping.containsAnyObject, isDropDownFields: true },
  { key: 'IRA_NO', value: 'descriptions.originalReport.iraNumber', operator: operatorMapping.contains },
  { key: 'CAUSER', value: 'descriptions.possibleCauser.locationInternalIsChosen', operator: operatorMapping.equal, isDropDownFields: true, format: 'boolean' },
  { key: 'SUPPLIER_NO', value: 'descriptions.possibleCauser.locationExternal.supplierNumber', operator: operatorMapping.contains },
  { key: 'POSSIBLE_CAUSER', value: 'descriptions.possibleCauser.locationInternal.possibleCauser.summary', operator: operatorMapping.contains },
  {
    key: 'SUPPLIER_NAME',
    value: [
      'descriptions.possibleCauser.locationExternal.supplierName',
      'descriptions.possibleCauser.locationExternal.supplierAddress.city',
      'descriptions.possibleCauser.locationExternal.supplierAddress.country',
      'descriptions.possibleCauser.locationExternal.supplierAddress.postalCode',
      'descriptions.possibleCauser.locationExternal.supplierAddress.street',
    ],
    isMultiFilter: true,
    operator: operatorMapping.contains,
  },
  { key: 'TIER1_SUPPLIER_NO', value: 'descriptions.possibleCauser.locationExternal.tier1SupplierNumber', operator: operatorMapping.contains },
  {
    key: 'TIER1_SUPPLIER_NAME',
    value: [
      'descriptions.possibleCauser.locationExternal.tier1SupplierName',
      'descriptions.possibleCauser.locationExternal.tier1SupplierAddress.city',
      'descriptions.possibleCauser.locationExternal.tier1SupplierAddress.country',
      'descriptions.possibleCauser.locationExternal.tier1SupplierAddress.postalCode',
      'descriptions.possibleCauser.locationExternal.tier1SupplierAddress.street',
    ],
    isMultiFilter: true,
    operator: operatorMapping.contains,
  },
  {
    key: 'CONTACT_PERSON_MP', value: 'descriptions.possibleCauser.locationExternal.additionalContactPerson.summary', operator: operatorMapping.contains,
  },
  {
    key: 'PART_NO',
    value: [
      'affected_hardware.affectedHardwareWithPartChange.partNumberNew',
      'affected_hardware.affectedHardwareWithoutPartChange.partNumberNew',
      'affected_software.softwareWithFlashing.flashingPartList.partNumberNew',
      'affected_software.softwareWithCoding.codingPartList.partNumberNew',
    ],
    isMultiFilter: true,
    operator: operatorMapping.contains,
  },
  { key: 'MB_OS_RELEVANCY', value: 'affected_software.mbosDetails.isMbos', operator: operatorMapping.equal, isDropDownFields: true, format: 'ENUM_NAME' },
  { key: 'CAMPAIGN_NUMBER', value: 'sub_campaign_feedbacks.campaigns', isMultiFilter: true, operator: operatorMapping.containsObject },
  { key: 'FREE_TEXT', value: 'all_fields', operator: operatorMapping.contains },
  { key: 'TYPE', value: 'campaigns.type', operator: operatorMapping.equal, isDropDownFields: true, format: 'ENUM_NAME' },
];

export const combinedMenus = [...tableMenu, ...otherField, ...lateralMenu];
export const opensearchFieldMapping = combinedMenus.map((item) => ({ [item.key]: item.value })).reduce((acc, item) => ({ ...acc, ...item }), {});

export const limitOfVolumeTabsMapping = {
  vehicleModelDesignation: 'VEHICLE_MODEL_DESIGNATION',
  aggregate: 'AGGREGATE',
  specialEquipment: 'SPECIAL_EQUIPMENT',
  countryVariants: 'COUNTRY_VARIANTS',
  paintCode: 'PAINT_CODE',
  codeRules: 'CODE_RULE',
  vehicleGroups: 'CLEAN_DIRTY_POINT',
  summary: 'SUMMARY',
};

// Main object, default on empty data
export const opensearchFilterBuilder = (isSubCROverview) => {
  const defaultFilter = () => [{
    field: isSubCROverview ? 'sub_campaigns.id' : 'campaigns.id',
    value: 'CR',
    operator: operatorMapping.contains,
  }];

  return { filters: { and: defaultFilter() } };
};

const filterValueHandlers = {
  [filterField.CAMPAIGN_NUMBER]: (value) => (
    (value instanceof Array)
      ? `[${value.reduce((acc) => (`${acc}${acc.length > 0 ? ', ' : ''}{"campaignManagerEntry":{"campaignNumber":{ "value":"${value}" }}}`), '')}]`
      : `[{"campaignManagerEntry" :{"campaignNumber" :{ "value": "${value}" }}}]`
  ),
  [CAMPAING.toLowerCase()]: (value) => (
    (value instanceof Array)
      ? `[${value.reduce((acc) => (`${acc}${acc.length > 0 ? ', ' : ''}{"campaignManagerEntry":{"campaignNumber":{ "value":"${value}" }}}`), '')}]`
      : `[{"campaignManagerEntry" :{"campaignNumber" :{ "value": "${value}" }}}]`
  ),
  [filterField.CLASSIFICATION]: (value) => value?.map((result) => result),
  [filterField.AFFECTED_PLANTS]: (value) => (
    (value instanceof Array)
      ? `[${value.map((item) => (`{"wkzNumber" :{ "value": "${item.wkzNumber}" }}`))}]`
      : `{"wkzNumber" :{ "value": "${value}" }}`
  ),
  [filterField.CAUSER]: (value) => (value === INTERNAL),
  [filterField.AFFECTED_MODEL_SERIES]: (value) => (
    (value instanceof Array)
      ? `[${value.map((item) => (`{"modelSerie":{ "value": "${item}" }}`))}]`
      : `{"modelSerie" :{ "value": "${value}" }}`
  ),
  [STATUS]: (value) => (
    {
      CRs: value.filter((item) => item.type[0] === MAIN_CR).map((item) => item.key),
      subCRs: value.filter((item) => item.type[0] === SUB_CR).map((item) => item.key),
    }
  ),
};

const filterValue = (filter, value) => {
  const handler = filterValueHandlers[filter.key] || filterValueHandlers[filterField[filter.key]] || ((val, filter) => val);

  return handler(value, filter);
};

export const buildOpensearchQueryData = (filters, isSubCROverview = false) => {
  const filterData = combinedMenus.filter((item) => {
    const value = filters[item.key];

    if (value === undefined || value === '') return false;
    if (Array.isArray(value)) return value.some(Boolean);

    return true;
  });
  let bodyData = opensearchFilterBuilder(isSubCROverview);
  const mappingFields = (name) => {
    const found = combinedMenus.filter((nameField) => nameField.key === name)[0];

    return isSubCROverview ? found?.value?.replace('campaigns', 'sub_campaigns') : found?.value;
  };

  if (filterData.length > 0) {
    const filterSum = [];
    filterData
      .map((filter, index) => {
        filterSum.push(
          {
            field: mappingFields(filter.key),
            value: filterValue(filter, filters[filter.key]),
            operator: filter.operator,
          },
        );

        if (filter.format) {
          filterSum[index] = { ...filterSum[index], format: filter.format };
        }

        return filterSum[index];
      });

    const isCampaignNumber = filterSum.find((item) => item.field === 'sub_campaign_feedbacks.campaigns');
    const filtersCrAndSubCRBuilder = () => {
      const isSubCR = filterSum.find((item) => item.field.includes('sub_campaigns'));
      const formatQuery = filterData.map((filter, index) => {
        if (filter.key === STATUS) {
          return undefined;
        }

        if (filter.isInCRandSubCR) {
          return {
            or: [
              filterSum[index],
              {
                child: {
                  filters: { ...filterSum[index], field: `sub_${filterSum[index].field}` },
                },
              },
            ],
          };
        }

        if (filter.key === filterField.PART_NO || filter.key === filterField.SUPPLIER_NAME || filter.key === filterField.TIER1_SUPPLIER_NAME) {
          return {
            or: filter?.value?.map((item) => ({
              field: item,
              operator: filterSum[index].operator,
              value: filterSum[index].value,
            })),
          };
        }

        if ([filterField.CAMPAIGN_NUMBER, CAMPAING.toLowerCase()].includes(filter.key)) {
          return {
            child: {
              filters: {
                and: [
                  filterSum[index],
                ],
              },
            },
          };
        }

        if ((isSubCR?.field !== filterSum[index].field && filter.key !== STATUS)) {
          return filterSum[index];
        }
      });

      // if child is out of or
      const subCrStatus = filterSum.find((item) => item.field === 'campaigns.status.value');
      const formingChild = (child) => {
        formatQuery.push({
          child: {
            filters: child,
          },
        });
      };

      if (isSubCR) {
        formingChild(isSubCR);
      }

      // CR-level and SubCR-level status selections are combined with OR: a row matches if
      // its own status matches OR if it has a sub-campaign matching the selected sub-statuses.
      if (subCrStatus) {
        const entries = [
          subCrStatus.value.CRs.length > 0 && {
            field: subCrStatus.field,
            value: subCrStatus.value.CRs,
            operator: subCrStatus.operator,
            ...(subCrStatus.format ? { format: subCrStatus.format } : {}),
          },
          subCrStatus.value.subCRs.length > 0 && {
            child: {
              filters: {
                value: subCrStatus.value.subCRs,
                field: `sub_${subCrStatus.field}`,
                format: 'ENUM_NAME',
                operator: 'IN',
              },
            },
          },
        ].filter(Boolean);

        if (entries.length > 1) {
          formatQuery.push({ or: entries });
        } else if (entries.length === 1) {
          formatQuery.push(entries[0]);
        }
      }

      return formatQuery.filter((item) => item !== undefined);
    };
    bodyData = { filters: isCampaignNumber ? filtersCrAndSubCRBuilder() : { and: filtersCrAndSubCRBuilder() } };
  }

  return bodyData;
};

// AFFECTEDVEHICLES

export const filterAffVehiclesResults = (arr = [], via) => {
  const regEx1 = via === 'SERIES'
    ? new RegExp(/series\[(\d+)\].typeVersions\[(\d+)\].plants\[(\d+)\].*value=(\w+)/)
    : new RegExp(/affectedPlants\[(\d+)\].affectedSeries\[(\d+)\].typeVersions\[(\d+)\].*value=(\w+)/);
  const regEx2 = via === 'SERIES'
    ? new RegExp(/plants\[(\d+)\].*/)
    : new RegExp(/typeVersions\[(\d+)\].*/);
  const result = {};
  const finalResult = [];

  arr.forEach((element) => {
    const match = element.match(regEx1);
    const firstIndex = match?.[1];
    const value = match?.[2];

    if (!firstIndex || !value) {
      finalResult.push(element);

      return;
    }

    if (!result[firstIndex]) {
      result[firstIndex] = {};
    }

    if (!result[firstIndex][value]) {
      result[firstIndex][value] = [];
    }
    result[firstIndex][value].push(element);
  });

  for (const index in result) {
    for (const value in result[index]) {
      const finalIndex = result[index][value].map((el) => el.match(regEx2)?.[1]);

      if (via === 'SERIES') {
        finalResult.push(`series[${index}].typeVersions.plants[${finalIndex[finalIndex.length - 1]}].value=${value}`);
      } else {
        finalResult.push(`affectedPlants[${index}].affectedSeries.typeVersions[${finalIndex[finalIndex.length - 1]}].value=${value}`);
      }
    }
  }

  return finalResult;
};

export const getCRSearchFromCRInfo = (crInfo, searchCR) => {
  const { descriptions, affected_hardware, affected_model_series, affected_software, affected_vehicles, campaigns, sub_campaigns,
    classifications, recipients, sub_campaign_feedbacks, limitation_of_volume, sub_campaign_notes } = crInfo?.highlights
      || crInfo.highlights?.campaigns || {};
  let firstTabFound = '';

  const resultCounter = crInfo?.totalCount || 0;

  if (sub_campaign_notes) {
    sub_campaign_notes.map((item) => {
      const keyName = item.path.slice(item.path.indexOf('[') + 1, item.path.indexOf(']'));
      const foundKey = Object.keys(crInfo.highlights).find((key) => key.includes(keyName.toLowerCase()));

      if (foundKey) {
        crInfo.highlights[foundKey].push({ path: item.path, value: item.value });
      } else {
        crInfo.highlights[keyName.toLowerCase()] = [{ path: item.path, value: item.value }];
      }

      return crInfo.highlights;
    });
  }

  if (sub_campaigns) {
    sub_campaigns.map((item) => {
      crInfo.highlights[campaignsTab].push({ path: item.path, value: item.value });

      return crInfo.highlights;
    });
  }

  const sections = {
    feedback: sub_campaign_feedbacks || crInfo.highlights.feedback || [],
    description: descriptions || crInfo.highlights.description || [],
    classification: classifications || crInfo.highlights.classification || [],
    affectedHardware: affected_hardware || crInfo.highlights.affectedHardware || [],
    affectedSoftware: affected_software || crInfo.highlights.affectedSoftware || [],
    affectedVehicles: affected_vehicles || crInfo.highlights.affectedVehicles || [],
    recipients: recipients || crInfo.highlights.recipients || [],
    campaign: campaigns || crInfo.highlights.campaign || [],
    sub_campaigns: sub_campaigns || crInfo.highlights.sub_campaigns || [],
    limitationOfVolume: limitation_of_volume || crInfo.highlights.limitationOfVolume || [],
  };

  const crSearch = {
    active: true,
    searchedText: searchCR,
    resultCounter,
    sections,
    results: [],
    fieldSelected: null,
    selectedCoincidenceFieldId: null,
  };
  const limitationOfVolume = Object.keys(crSearch.sections.limitationOfVolume);
  const isLimitationOfVolumeFilled = limitationOfVolume.length > 0;

  Object.keys(tabsCRSearchOrdered()).forEach((tabb) => {
    const resultsTab = crSearch.sections[tabb]?.map((field, indexField) => ({ tab: tabb, field, selected: (indexField === 0 && firstTabFound === ''), sameTabSelected: (firstTabFound === '') })) ?? [];
    if (resultsTab.length > 0) firstTabFound = tabb;
    crSearch.results = crSearch.results?.concat(resultsTab);
  });

  if (isLimitationOfVolumeFilled) {
    limitationOfVolume.forEach((item) => {
      return crSearch.sections.limitationOfVolume[item]?.map((plant) => (
        crSearch.results.push({
          tab: 'affectedVehicles',
          field: { path: plant.path, value: plant.value },
          selected: (crSearch.results.length === 0),
          plant: item,
          sameTabSelected: (firstTabFound === ''),
        })));
    });
  }

  crSearch.fieldSelected = crSearch.results?.find((field /* : any */) => field.selected) ?? null;

  return crSearch;
};
